import React, { Component } from "react";
import EnrollmentFormPV from "./EnrollmentFormPV";
import AuthA from "../../store/actions/AuthA";

import { connect } from "react-redux";
import axios from "axios";

class EnrollmentFormPC extends Component {
  state = {
    applicationType: "",
    clicked: false,
    studentNumber: "",
    student: null,
    section: null,
    gradeLevel: "",
    verificationId: "",
  };

  logout = () => {
    this.props.authFn.logout();
  };

  clickApplication = (type) => {
    this.setState({
      applicationType: type,
      clicked: type === "" ? false : true,
    });
  };

  handleChange = (e, { name, value }) => this.setState({ [name]: value });

  // handleGetStudentData = (studentNumber) => {
  //   axios.get(`${process.env.REACT_APP_URL}/students/findOne?filter[where][active]=true&filter[where][studentNumber]=${studentNumber}`)
  //   .then(response => {
  //     // get previous school year data
  //     // for now hindi muna isa pa lang naman yung previous e
  //     axios.get(`${process.env.REACT_APP_URL}/sectionStudents/findOne?filter[where][active]=true&filter[where][studentId]=${response.data.studentId}&filter[include]=section`)
  //     .then(response2 => {
  //       this.setState({ student: response.data, section: response2.data.section, gradeLevel: response2.data.section.gradeLevel});
  //     })
  //     .catch((error) => {
  //       this.setState({ student: null, section: null});
  //     });
  //   })
  //   .catch((error) => {
  //     this.setState({ student: null, section: null});
  //   });
  //   // this.setState({ submittedName: name, submittedEmail: email })
  // }

  handleGetStudentData = (studentNumber) => {
    if (!studentNumber.trim()) {
      alert("Please enter a valid Student Number");
      return;
    }

    console.log("Fetching student data for:", studentNumber);

    axios
      .get(
        `${process.env.REACT_APP_URL}/students/findOne?filter[where][active]=true&filter[where][studentNumber]=${studentNumber}`
      )
      .then((response) => {
        console.log("Student data received:", response.data);

        // Get previous school year data
        axios
          .get(
            `${process.env.REACT_APP_URL}/sectionStudents/findOne?filter[where][active]=true&filter[where][studentId]=${response.data.studentId}&filter[include]=section`
          )
          .then((response2) => {
            console.log("Section data received:", response2.data);

            // Calculate next grade level
            const currentGradeLevel = response2.data.section.gradeLevel;
            const nextGradeLevel =
              this.calculateNextGradeLevel(currentGradeLevel);

            console.log(
              "Current grade:",
              currentGradeLevel,
              "Next grade:",
              nextGradeLevel
            );

            this.setState(
              {
                student: response.data,
                section: response2.data.section,
                gradeLevel: currentGradeLevel,
                nextGradeLevel: nextGradeLevel,
                clicked: true, // Enable the form
              },
              () => {
                console.log(
                  "State updated with student data:",
                  this.state.student
                );
              }
            );
          })
          .catch((error) => {
            console.error("Error fetching section data:", error);
            this.setState({
              student: response.data,
              section: null,
              clicked: true, // Still enable the form even if section data is missing
            });
          });
      })
      .catch((error) => {
        console.error("Error fetching student data:", error);
        alert(
          "Student not found. Please check your student number and try again."
        );
        this.setState({ student: null, section: null });
      });
  };

  // Helper method to calculate next grade level
  calculateNextGradeLevel = (currentGradeLevel) => {
    // Map of grade levels to their next level
    const gradeLevelMap = {
      Nursery: "Kinder",
      Kinder: "Grade 1",
      "Grade 1": "Grade 2",
      "Grade 2": "Grade 3",
      "Grade 3": "Grade 4",
      "Grade 4": "Grade 5",
      "Grade 5": "Grade 6",
      "Grade 6": "Grade 7",
      "Grade 7": "Grade 8",
      "Grade 8": "Grade 9",
      "Grade 9": "Grade 10",
      "Grade 10": "Grade 11",
      "Grade 11": "Grade 12",
    };

    return gradeLevelMap[currentGradeLevel] || "";
  };

  handleVerifyStudent = (verificationId) => {
    if (!verificationId.trim()) {
      alert("Please enter a valid Student Number or LRN");
      return;
    }

    console.log("Verifying student with ID:", verificationId);

    // First try to find by student number
    this.findStudentByField("studentNumber", verificationId)
      .then((student) => {
        if (student) {
          this.processStudentData(student);
        } else {
          // If not found by student number, try LRN
          return this.findStudentByField("lrn", verificationId);
        }
      })
      .then((student) => {
        if (student) {
          this.processStudentData(student);
        }
      })
      .catch((error) => {
        console.error("Error verifying student:", error);
        alert(
          "Student not found. Please check your Student Number or LRN and try again."
        );
      });
  };

  // Helper method to find student by a specific field
  findStudentByField = (field, value) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${process.env.REACT_APP_URL}/students/findOne?filter[where][active]=true&filter[where][${field}]=${value}`
        )
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            // Not found is okay, we'll try the other field
            resolve(null);
          } else {
            reject(error);
          }
        });
    });
  };

  // Process the student data once found
  processStudentData = (student) => {
    // Get previous school year data
    axios
      .get(
        `${process.env.REACT_APP_URL}/sectionStudents/findOne?filter[where][active]=true&filter[where][studentId]=${student.studentId}&filter[include]=section`
      )
      .then((response2) => {
        console.log("Section data received:", response2.data);

        // Calculate next grade level
        const currentGradeLevel = response2.data.section.gradeLevel;
        const nextGradeLevel = this.calculateNextGradeLevel(currentGradeLevel);

        console.log(
          "Current grade:",
          currentGradeLevel,
          "Next grade:",
          nextGradeLevel
        );

        this.setState(
          {
            student: student,
            section: response2.data.section,
            gradeLevel: currentGradeLevel,
            nextGradeLevel: nextGradeLevel,
            clicked: true, // Enable the form
          },
          () => {
            console.log("State updated with student data:", this.state.student);
          }
        );
      })
      .catch((error) => {
        console.error("Error fetching section data:", error);
        this.setState({
          student: student,
          section: null,
          clicked: true, // Still enable the form even if section data is missing
        });
      });
  };

  render() {
    console.log("Rendering EnrollmentFormPC with state:", this.state);

    return (
      <EnrollmentFormPV
        applicationType={this.state.applicationType}
        clicked={this.state.clicked}
        verificationId={this.state.verificationId}
        student={this.state.student}
        section={this.state.section}
        gradeLevel={this.state.gradeLevel}
        nextGradeLevel={this.state.nextGradeLevel}
        auth={this.props.auth}
        clickApplication={this.clickApplication}
        handleChange={this.handleChange}
        handleVerifyStudent={this.handleVerifyStudent}
        logout={this.logout}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authFn: AuthA(dispatch),
  };
};

const mapStateToProps = (state) => {
  return {
    auth: state.AuthR.auth,
    loginErr: state.AuthR.loginErr,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EnrollmentFormPC);
